import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';

type Side = 'top' | 'right' | 'bottom' | 'left' | undefined;

interface BasicTooltipProps {
  children: React.ReactNode;
  content: string;
  side?: Side;
}

export default function BasicTooltip({
  children,
  content,
  side = 'top',
}: BasicTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger>{children}</TooltipTrigger>
      <TooltipContent side={side}>
        <p className='font-medium text-primary'>{content}</p>
      </TooltipContent>
    </Tooltip>
  );
}
